import { useAuth } from '../contexts/AuthContext';

/**
 * Centralized ad visibility hook.
 * Single source of truth for all ad components (banners, pre-roll, pop-under, overlay).
 *
 * Rules:
 * - Premium subscribers: NO ads at all
 * - Owner / Admin: NO ads at all
 * - Creators (non-premium): ALL ads EXCEPT pop-under
 * - Free users: ALL ads
 */
export const useShowAds = () => {
  const { isPremium, isOwner, isAdminRole, isCompany } = useAuth();

  const isStaff = isOwner || isAdminRole;

  // Banners + Pre-roll + Overlay: hidden for premium and owner/admin
  const showAds = !isPremium && !isStaff;

  // Pop-under: hidden for premium, owner/admin, AND creators
  const showPopunder = !isPremium && !isStaff && !isCompany;

  return { showAds, showPopunder };
};
